<div *ngIf="nodeValue" class="bg-bluegray-50 h-full">
   <div
      class="bg-white flex flex-column justify-content-between align-items-center gap-3 w-full px-3"
   >
      <span class="cursor-pointer w-full justify-content-end flex pt-4 mr-2" (click)="this.closeSidebar.emit()">
         <i class="text-bluegray-800 pi pi-times"></i>
      </span>

      <div class="flex justify-content-start align-items-center w-full gap-3 pb-3">
         <div class="bg-blue-50 p-3 border-1 border-blue-100 border-round-lg">
            <i class="pi pi-filter text-blue-700 text-lg"></i>
         </div>
         <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
            {{ 'DATA.MODULES.INSPECTORS.SEGMENT.TITLE' | translate }}
            <div class="text-sm font-normal text-600">
               {{ 'DATA.MODULES.INSPECTORS.SEGMENT.DESCRIPTION' | translate }}
            </div>
         </div>
      </div>

      <div *ngIf="visibleTabs().length > 1" class="tab-nav tab-nav--centered w-full">
         <button
            *ngFor="let tab of visibleTabs()"
            type="button"
            class="tab-nav__item"
            [class.tab-nav__item--active]="activeTab() === tab.value"
            (click)="activeTab.set(tab.value)"
         >
            <lucide-icon *ngIf="tab.value === 'preview'" name="eye" [size]="15"></lucide-icon>
            <lucide-icon *ngIf="tab.value === 'config'" name="settings" [size]="15"></lucide-icon>
            <span>{{ tab.label }}</span>
         </button>
      </div>
   </div>

   <!-- Preview Tab -->
   <div *ngIf="activeTab() === 'preview'" class="p-3 overflow-auto h-full pb-4">
      <div class="flex flex-column gap-4">
         <span class="font-semibold text-900">Segmento seleccionado</span>

         <app-segment-filters-preview
            *ngIf="selectedSegment(); else emptyPreview"
            [name]="selectedSegment()?.name ?? null"
            [filters]="selectedSegment()?.filters ?? []"
            [collectors]="collectors()"
            [portfolios]="portfolios()"
            [showStatusBadges]="true"
            [isDefault]="selectedSegment()?.default ?? false"
            [isInUse]="selectedSegment()?.isInUse ?? false"
         />

         <ng-template #emptyPreview>
            <div class="flex flex-column align-items-center justify-content-center py-8 text-400 opacity-60">
               <i class="pi pi-filter text-5xl mb-3"></i>
               <span>{{ 'DATA.MODULES.INSPECTORS.SEGMENT.PREVIEW.EMPTY' | translate }}</span>
            </div>
         </ng-template>

         <div *ngIf="errors().length" class="mt-2">
            <div *ngFor="let e of errors()" class="text-red-600 text-sm">
               {{ e.errorMessage }}
            </div>
         </div>
      </div>
   </div>

   <!-- Config Tab -->
   <div *ngIf="activeTab() === 'config'" class="p-3 overflow-auto h-full pb-4">
      <div class="flex flex-column gap-4">
         <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
               <span class="font-semibold text-900">{{ 'DATA.MODULES.INSPECTORS.SEGMENT.TITLE' | translate }}</span>
               <span class="text-sm text-500">{{ 'DATA.MODULES.INSPECTORS.SEGMENT.DESCRIPTION' | translate }}</span>
            </div>

            <div class="flex flex-column gap-2">
               <p-dropdown
                  [options]="segments()"
                  [(ngModel)]="selectedSegmentId"
                  optionLabel="name"
                  optionValue="id"
                  [placeholder]="'DATA.MODULES.INSPECTORS.SEGMENT.CONFIG.SEGMENT_PLACEHOLDER' | translate"
                  [showClear]="true"
                  styleClass="w-full"
                  (onChange)="onSelectSegment($event)"
               >
                  <ng-template let-option pTemplate="item">
                     <div *ngIf="option" class="flex align-items-center gap-2">
                        <i class="pi pi-filter text-blue-600"></i>
                        <span>{{ option.name }}</span>
                        <span
                           *ngIf="option.default"
                           class="text-xs px-2 py-0.5 border-round-md bg-orange-50 text-orange-700 border-1 border-orange-100 flex align-items-center gap-1"
                        >
                           <i class="pi pi-star-fill" style="font-size: 0.65rem"></i>
                           {{ 'DATA.MODULES.INSPECTORS.SEGMENT.BADGE_DEFAULT' | translate }}
                        </span>
                        <span
                           *ngIf="option.isInUse"
                           class="text-xs px-2 py-0.5 border-round-md bg-teal-50 text-teal-700 border-1 border-teal-100 flex align-items-center gap-1"
                        >
                           <i class="pi pi-check-circle" style="font-size: 0.65rem"></i>
                           {{ 'DATA.MODULES.INSPECTORS.SEGMENT.BADGE_IN_USE' | translate }}
                        </span>
                     </div>
                  </ng-template>
               </p-dropdown>

                <div *ngIf="editSegmentUrl()" class="flex justify-content-end mt-1">
                    <a
                        [href]="editSegmentUrl()"
                        target="_blank"
                        class="text-xs text-blue-600 hover:text-blue-800 font-medium no-underline flex align-items-center gap-1"
                    >
                        <i class="pi pi-external-link"></i>
                       Editar segmento seleccionado
                    </a>
                </div>
            </div>
         </div>

         <!-- Segment preview when selected -->
         <app-segment-filters-preview
            *ngIf="selectedSegment()"
            [name]="selectedSegment()?.name ?? null"
            [filters]="selectedSegment()?.filters ?? []"
            [collectors]="collectors()"
            [portfolios]="portfolios()"
            [showStatusBadges]="true"
            [isDefault]="selectedSegment()?.default ?? false"
            [isInUse]="selectedSegment()?.isInUse ?? false"
         />

         <div *ngIf="errors().length" class="mt-2">
            <div *ngFor="let e of errors()" class="text-red-600 text-sm">
               {{ e.errorMessage }}
            </div>
         </div>
      </div>
   </div>
</div>
